import { MenuItem } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { MenuService } from './menu.service';
import { UserRoleEnum } from '@app/shared/enums/UserRoleEnum';
import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate, OnDestroy {

  urls: string[];
  $destroy = new Subject();

  constructor(
    public authService: AuthService,
    public router: Router,
    private menuSrv: MenuService
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot
  ) {
    this.menuSrv.getMenu.pipe(takeUntil(this.$destroy)).subscribe(urls => {
      this.urls = urls;
    });
    const notAuthenticated = !await this.authService.isAuthenticated();
    if (notAuthenticated) {
      this.router.navigate(['/login']);
      return false;
    } else {
      const url = route.routeConfig.path;
      if (url && url !== '/' && this.urls && this.urls.length > 0 && !this.urls.find( path => path.includes(url))) {
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    }
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
